import i18n from '../../locales/index'
import axios from 'axios'
import { Message, Spin } from 'view-design'
import restful from '@/store/vuex'

const state = {
  ...restful.states('promote_company')
}

const getters = {
  ...restful.getters('promote_company')
}

const actions = {
  ...restful.actions('promote_companies'),
  async generate_bill ({ commit }, { id, description }) {
    Spin.show()
    const res = await axios.post(`promote_companies/${id}/calc_rebate`, { description })
    Spin.hide()
    Message.success(i18n.t('store_modules_promote_company_1338'))
    return res
  }
}

const mutations = {
  ...restful.mutations('promote_company')
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
